export default "__VITE_ASSET__e394892d__"